import { Body, Box, Icon } from '@hover/blueprint';
import { iPlus } from '@hover/icons';
import { includes } from 'ramda';
import React, { useState } from 'react';

import { useHomeownerAppContext } from 'src/modules/homeownerApp/hooks';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';
import { MIME_TYPES } from 'src/shared/utils/photoMimeTypes';

import { UploadInput } from '../../UploadInput/UploadInput';

type HTMLInputEventTarget = HTMLInputElement & EventTarget;

const UploadPhotoInput = () => {
  const { setImageFileToUpload } = useHomeownerAppContext();

  const [isDragging, setIsDragging] = useState(false);
  const [invalidUpload, setInvalidUpload] = useState<false | string>(false);

  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);

  const onUploadPhotoChange: (
    event: React.FormEvent<HTMLInputElement>,
  ) => void = event => {
    setInvalidUpload(false);
    const inputTarget = event.target as HTMLInputEventTarget;
    const photoUploadFile = inputTarget.files && inputTarget.files[0];

    if (!photoUploadFile || !includes(photoUploadFile.type, MIME_TYPES)) {
      setInvalidUpload(t('uploadPhotoSheet.invalidUploadMimeType'));
      return;
    }

    setImageFileToUpload(photoUploadFile);
  };

  return (
    <Box
      alignItems="center"
      bg={isDragging ? 'darkAlpha.50' : 'transparent'}
      borderColor="neutral.300"
      borderRadius="200"
      borderStyle="dashed"
      flexDirection="column"
      justifyContent="center"
      m={0}
      position="relative"
      sx={{ aspectRatio: '3/4' }}
      width="100%"
    >
      {invalidUpload && (
        <Body
          bg="darkAlpha.100"
          borderRadius="200"
          color="danger.500"
          m="100"
          p="100"
          position="absolute"
          size={300}
          top="0"
          zIndex={1}
        >
          {t('home.invalidUpload')}
          <Body
            cursor="pointer"
            onClick={() => {
              setInvalidUpload(false);
              setIsDragging(false);
            }}
            textDecoration="underline"
          >
            {t('home.invalidConfirm')}
          </Body>
        </Body>
      )}
      <Icon color="neutral.500" icon={iPlus} size="huge" />
      <Body color="neutral.500">{t('home.uploadYourSpace')}</Body>
      <UploadInput
        onUploadPhotoChange={onUploadPhotoChange}
        setInvalidUpload={setInvalidUpload}
        setIsDragging={setIsDragging}
      />
    </Box>
  );
};

export { UploadPhotoInput };
